import React from 'react';
import { NavLink } from 'react-router-dom';
// import img4 from '../../images/img169 2.png'

// Use uploaded document image instead of placeholder local asset
var img1 = require('./../../images/left-men.png');
var img2 = require('./../../images/background/bg-4.png');
var img3 = require('./../../images/background/bg-site.png');
var img4 = require('./../../images/img1692.png');

class OurMission extends React.Component {
    render() {
        return (
            <>
                <div
                    className="section-full mobile-page-padding mission-outer-section p-t80 p-b30 bg-gray bg-no-repeat bg-right-center"
                    style={{
                        backgroundImage: 'url(' + img1 + '), url(' + img2 + ')'
                    }}
                >
                    <div className="section-content">
                        <div className="container">

                            {/* TITLE */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one">
                                            <span className="font-weight-300 text-primary">Our</span> Mission
                                        </h2>
                                    </div>
                                </div>
                            </div>

                            <div className="row">

                                {/* LEFT PANEL */}
                                <div className="col-md-4 col-sm-6">
                                    <div
                                        className="mission-left bg-white m-b30 p-a30 bg-no-repeat bg-bottom-left"
                                        style={{ backgroundImage: 'url(' + img3 + ')' }}
                                    >
                                        <h3 className="m-t0">
                                            <span className="font-weight-100">Core Engineering Scope</span>
                                        </h3>

                                        <p>
                                            We deliver integrated electro-mechanical engineering solutions
                                            covering design, manufacturing, supply, installation, and maintenance
                                            for infrastructure and industrial systems.
                                        </p>

                                        <ul className="list-angle-right anchor-line">
                                            <li><NavLink to="/services">HVAC Systems</NavLink></li>
                                            <li><NavLink to="/services">Fire Protection Systems</NavLink></li>
                                            <li><NavLink to="/services">Water Supply & Irrigation</NavLink></li>
                                            <li><NavLink to="/services">Sanitary & Plumbing Systems</NavLink></li>
                                            <li><NavLink to="/services">Industrial & Electro-Mechanical Installation</NavLink></li>
                                        </ul>

                                        <div className="text-right">
                                            <NavLink to="/about" className="site-button-link">
                                                Read More <i className="fa fa-angle-right arrow-animation" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>

                                {/* MIDDLE IMAGE */}
                                <div className="col-md-4 col-sm-6">
                                    <div
                                        className="mission-mid bg-no-repeat bg-cover m-b30"
                                        style={{ backgroundImage: 'url(' + img4 + ')' }}
                                    />
                                </div>

                                {/* RIGHT CONTACT */}
                                <div className="col-md-4 col-sm-12">
                                    <div className="contact-home1-left bg-dark p-a30 m-b0">
                                        <h3 className="text-white m-t0">
                                            <span className="font-weight-100">Get In</span> Touch
                                        </h3>

                                        <form className="cons-contact-form2 form-transparent">
                                            <div className="input input-animate">
                                                <label>Name</label>
                                                <input type="text" required />
                                            </div>

                                            <div className="input input-animate">
                                                <label>Email</label>
                                                <input type="email" required />
                                            </div>

                                            <div className="input input-animate">
                                                <label>Phone</label>
                                                <input type="text" required />
                                            </div>

                                            <div className="input input-animate">
                                                <label>Message</label>
                                                <textarea required />
                                            </div>

                                            <div className="text-center p-t10">
                                                <button type="submit" className="site-button btn-effect">
                                                    Submit Now
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="hilite-title text-left p-l50 text-uppercase text-pop-up-top">
                        <strong>Mission</strong>
                    </div>
                </div>
            </>
        );
    }
}

export default OurMission;